
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/butlletins",
      function () {
        return require("private-next-pages/corporatiu/butlletins/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/butlletins"])
      });
    }
  